import React, { Component } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

export class LoonSlipPdf extends Component {
  render() {
    const styles = StyleSheet.create({
      page: {
        display: "flex",
        flexDirection: "column",
        padding: 14,
        paddingTop: 40,
        fontSize: 10,
      },
      company_info_section: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        marginBottom: 30,
      },
      employee_info_section: {
        display: "flex",
        flexDirection: "row",
        marginBottom: 15,
      },
      image: {
        width: 60,
        marginRight: 20,
      },
      employee_info_section_left: {
        width: "45%",
      },
      employee_info_section_right: {
        marginLeft: 25,
        width: "40%",
      },
      employee_info: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: 8,
      },
      loonStrook: {
        display: "flex",
        flexDirection: "row",
      },
      col_1: {
        width: "20%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_1: {
        width: "20%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_1: {
        width: "20%",
      },
      col_2: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_2: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_2: {
        width: "15%",
      },
      col_3: {
        width: "5%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_3: {
        width: "5%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_3: {
        width: "5%",
      },
      col_4: {
        width: "32%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_4: {
        width: "32%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_4: {
        width: "32%",
      },
      col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
      },
      second_col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      third_col_5: {
        width: "15%",
        borderBottom: 1,
        borderLeft: 1,
      },
      col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderTop: 1,
        borderRight: 1,
      },
      second_col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderRight: 1,
      },
      third_col_6: {
        width: "12%",
        borderBottom: 1,
        borderLeft: 1,
        borderRight: 1,
        display: "flex",
        justifyContent: "flex-end",
        textAlign: "right",
      },
      col_header: {
        padding: 4,
        borderBottom: 1,
        fontWeight: 700,
      },
      col_footer: {
        padding: 4,
      },
      toelagen_label: {
        marginLeft: 4,
        marginBottom: 2,
        marginTop: 2,
      },
      toelagen_value: {
        marginLeft: 4,
        marginBottom: 2,
        marginTop: 2,
      },
      inhoudingen_label: {
        marginLeft: 4,
        marginBottom: 2,
        marginTop: 2,
      },
      inhoudingen_value: {
        marginLeft: 4,
        marginBottom: 2,
        marginTop: 2,
      },
      double: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      },
      inhoudingen_label_double: {
        marginLeft: 4,
        marginRight: 2,
        marginBottom: 4,
      },

      footer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        marginTop: "auto",
        fontSize: 8,
        marginBottom: 20,
      },

      section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
      },
      text: {
        fontSize: 5,
        fontWeight: 700,
      },
      text2: {
        fontSize: 10,
      },
    });

    const { loonslipData, inhoudingen, toelagen } = this.props;

    const inhoudingRowsLabel = inhoudingen.map((x) => {
      return (
        <Text style={styles.inhoudingen_label} key={x.label + x.bedrag}>
          {x.label}
        </Text>
      );
    });

    const inhoudingRowsValue = inhoudingen.map((x) => {
      return (
        <Text style={styles.inhoudingen_value} key={x.label + x.bedrag}>
          {x.bedrag}
        </Text>
      );
    });

    const toelagenRowsLabel = toelagen.map((x) => {
      return (
        <Text style={styles.toelagen_label} key={x.label + x.bedrag}>
          {x.label}
        </Text>
      );
    });

    const toelagenRowsValue = toelagen.map((x) => {
      return (
        <Text style={styles.toelagen_value} key={x.label + x.bedrag}>
          {x.bedrag.slice(0, x.bedrag.indexOf("("))}
        </Text>
      );
    });

    return (
      <Document>
        <Page size="A5" orientation="landscape" style={styles.page}>
          {/* loonstrook */}
          <View style={styles.loonStrook}>
            <View style={styles.col_1}>
              <Text style={styles.col_header}>ONTVANGSTEN</Text>
              <Text style={styles.toelagen_label}>BRUTO LOON</Text>
              {toelagenRowsLabel}
            </View>
            <View style={styles.col_2}>
              <Text style={styles.col_header}>BEDRAG SRD</Text>
              <Text style={styles.toelagen_value}>
                {loonslipData.brutoSalaris}
              </Text>
              {toelagenRowsValue}
            </View>
            <View style={styles.col_3}>
              <Text style={styles.col_header}> </Text>
            </View>
            <View style={styles.col_4}>
              <Text style={styles.col_header}>INHOUDINGEN</Text>
              {/* <View style={styles.double}>
                <Text style={styles.inhoudingen_label_double}>
                  LOONBELASTING
                </Text>
                <Text style={styles.inhoudingen_label_double}>
                  {loonslipData.belastingInhoudingBrutosalaris}
                </Text>
              </View>
              <View style={styles.double}>
                <Text style={styles.inhoudingen_label_double}>
                  HEFFINSKORTING
                </Text>
                <Text style={styles.inhoudingen_label_double}>
                  {loonslipData.heffingskorting}
                </Text>
              </View> */}
              <Text style={styles.inhoudingen_label}>
                Belasting inhouding bruto salaris
              </Text>
              <Text style={styles.inhoudingen_label}>
                A.O.V inhouding bruto salaris
              </Text>
              {inhoudingRowsLabel}
            </View>
            <View style={styles.col_5}>
              <Text style={styles.col_header}>BEDRAG SRD</Text>
              {/* <Text style={styles.inhoudingen_value}> </Text>
              <Text style={styles.inhoudingen_value}> </Text> */}
              <Text style={styles.inhoudingen_value}>
                {loonslipData.afTeDragenLoonbelasting}
              </Text>
              <Text style={styles.inhoudingen_value}>
                {loonslipData.aovBedrag}
              </Text>
              {inhoudingRowsValue}
            </View>
            <View style={styles.col_6}>
              <Text style={styles.col_header}> </Text>
            </View>
          </View>
          {/* second row */}
          <View style={styles.loonStrook}>
            <View style={styles.second_col_1}>
              <Text style={styles.col_footer}>TOTAAL ONTVANGEN</Text>
            </View>
            <View style={styles.second_col_2}>
              <Text style={styles.col_footer}>
                {loonslipData.totaalTeOntvangen}
              </Text>
            </View>
            <View style={styles.second_col_3}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.second_col_4}>
              <Text style={styles.col_footer}>TOTAAL INHOUDINGEN</Text>
            </View>
            <View style={styles.second_col_5}>
              <Text style={styles.col_footer}>
                {loonslipData.totaalInhoudingen}
              </Text>
            </View>
            <View style={styles.second_col_6}>
              <Text style={styles.col_footer}> </Text>
            </View>
          </View>

          {/* third row */}
          <View style={styles.loonStrook}>
            <View style={styles.third_col_1}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_2}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_3}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_4}>
              <Text style={styles.col_footer}> </Text>
            </View>
            <View style={styles.third_col_5}>
              <Text style={styles.col_footer}>NETTO LOON</Text>
            </View>
            <View style={styles.third_col_6}>
              <Text style={styles.col_footer}>{loonslipData.nettoInkomen}</Text>
            </View>
          </View>
          {/* loonstrook */}
          <View style={styles.footer}>
            <View>
              <Text>*belastbaar</Text>
            </View>
            <View>
              <Text>www.tax.sr</Text>
            </View>
            <View>
              <Text>POWERED BY NAMIDI</Text>
            </View>
          </View>
        </Page>
      </Document>
    );
  }
}

export default LoonSlipPdf;
